/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	
	// Select all links with hashes
jQuery('a.button[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = jQuery(this.hash);
      target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        jQuery('html, body').animate({
          scrollTop: target.offset().top - 180
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var target = jQuery(target);
          target.focus();
          if (target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            target.focus(); // Set focus again
          };
        });
      }
    }
  });
  
  
  function matchHeight(cssclass){
	  var highest = 0;
	  jQuery( cssclass ).each(function( index ) {
		  if(jQuery( this ).height() > highest){
			  highest = jQuery( this ).height();
		  }
		})
		console.log( cssclass + ": " + highest );
		jQuery( cssclass ).each(function( index ) {
		  jQuery( this ).height(highest);
		  
		})
  }
  
  if( jQuery( window ).width() > 813){
	  matchHeight('.product-title');
	  matchHeight('.product-subtitle');
	  matchHeight('.product-text');
	  matchHeight('.product-image');
	  matchHeight('.about-title');
	  matchHeight('.about-subtitle');
	  matchHeight('.about-text');
	  matchHeight('.about-image');
  }
  
  if( jQuery( window ).width() < 813){
	  jQuery( '#menu-main-menu a' ).each(function( index ) {
		  
		  jQuery( this ).click(function() {
			  jQuery('#off-canvas').foundation('close');
			  console.log('mobile click');
			  jQuery( "#menu-icon" ).toggleClass( 'hide' );
			  jQuery( "#menu-close" ).toggleClass( 'hide' );
		  
		  });
		  
		})
	  
  }
  
  jQuery( "#menu-btn" ).click(function() {
	  console.log( "mobile nav" );
	  jQuery( "#menu-icon" ).toggleClass( 'hide' );
	  jQuery( "#menu-close" ).toggleClass( 'hide' );
	});
	
	 jQuery( ".js-off-canvas-overlay" ).click(function() {
	  console.log( "js-off-canvas-overlay" );
	  jQuery( "#menu-icon" ).toggleClass( 'hide' );
	  jQuery( "#menu-close" ).toggleClass( 'hide' );
	});
	
  
 
  
  /*
  var sections = ['#product', '#how', '#about', '#contact'];
  var buttons = ['.menu-product', '.menu-how', '.menu-about', '.menu-contact'];
  var selected = 'home';
  
  jQuery(window).scroll(function(){
  	for(var i=0; i < sections.length; i++){
	    
	    if( isScrolledIntoView(jQuery(sections[i])) && sections[i] != selected){
	      //$(this).children('span').text('visible');
	      console.log(sections[i] + ' ' + i + ' ' + buttons[i] );
	      jQuery('.menuselected').removeClass('menuselected');
	      jQuery(buttons[i]).addClass('menuselected');
	      selected = sections[i];
	      
	      
	    }
	    else{
	      //jQuery('.menuselected').removeClass('menuselected');
	      
	    }
	    
	    if()
    }
  
});

function isScrolledIntoView(elem){
	
    var elem = jQuery(elem);
    var $window = jQuery(window);

    var docViewTop = $window.scrollTop();
    var docViewBottom = docViewTop + $window.height();

    var elemTop = elem.offset().top - 100;
    
    
    var elemBottom = elemTop + elem.height();

    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
}
	
	*/
	
	
}); 